<template>
  <ul class="recommend__box">
    <li class="recommend__item clearfix" v-for="(item, index) in dataList" :key="item.id" :class="{'recommend__item--left': index%2===0,'recommend__item--right': index%2!==0}">
      <div class="recommend__identify">
         <h3><img :src="item.picPc" :alt="item.name"></h3>
         <!-- <h3><span class="icon"><img src="/static/img/prodcution_icon.png" alt=""></span><i class="dot"></i><span class="title hyxbzz">{{item.name}}</span></h3> -->
        <h4 class="title__en">Professional real estate finance</h4>
        <h4 class="title__ch">专业的房产金融服务</h4>
        <!-- <img :src="item.picPc" :alt="item.name"> -->
      </div>
      <div class="recommend__introduce">
        <h3>{{item.name}}</h3>
        <p class="recommend__desc">{{item.remark}}</p>
        <div class="recommend__explain">
          <div>借款额度：{{item.borrowMoney}}</div>
          <div class="db-ib">还款方式：{{item.repaymentType}}</div>
          <div class="db-ib">期限范围：{{item.duration}}</div>
          <div>费率说明：{{item.rateExplain}}</div>
        </div>
        <div class="look__detail">
          <a href="javascript:void(0);" class="detail" @click="$router.push('/borrow/'+item.id)">[查看详情]</a>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>

  export default {
    name: 'BorrowList',
    props: {
      dataList: {
        type: Array,
        default: []
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../stylus/mixin'
.recommend__box
  padding 42px 0 24px 0
  .recommend__item
    position relative
    width 1088px
    height 368px
    margin 0 auto 50px
    list-style none
    &:last-child
      margin-bottom 0
    .recommend__identify, .recommend__introduce
      border-radius 5px
      box-shadow 0 1px 15px 3px rgba(0, 0, 0, 0.16)
      background-color #fff
    .recommend__identify
      // padding 0 20px
      background-image url(/static/img/black-twill.png)
      background-repeat repeat
      letter-spacing 1px
      position absolute
      top 0
      z-index 2
      text-align center
      width 368px
      height 350px
      img
        display block
        margin 0 auto
      h3
        height 42px
        font-size 0
        margin 120px 0 64px 0
        ellipsis()
      // .icon
      //   display inline-block
      //   width 85px
      //   height 65px
      //   overflow hidden
      //   color #000
      //   font-size 75px
      //   font-weight normal
      //   vertical-align middle
      //   img
      //     display block
      //     width 85px
      //     height 65px
      //     border none
      // .dot
      //   display inline-block
      //   width 6px
      //   height 6px
      //   margin 0 10px
      //   border-radius 3px
      //   background-color  #2b9efc
      //   vertical-align middle
      // .title
      //   max-width 200px
      //   text-align left
      //   ellipsis()
      //   display inline-block
      //   height 60px
      //   line-height 60px
      //   font-size 28px
      //   vertical-align middle
      .title__en
        font-size 14px
        ellipsis()
      .title__ch
        font-size 14px
        ellipsis()
    .recommend__introduce
      position relative
      margin-top 21px
      height 308px
      letter-spacing 3px
      color #333
      h3
        margin 22px 0 0 0
        ellipsis()
      .recommend__desc
        margin 22px 0 39px
        padding-right 68px
        font-size 16px
        line-height 26px
        height 106px
        overflow hidden
      .recommend__explain
        color #999
        font-size 0
        line-height 25px
        >div
          max-width 100%
          font-size 14px
          ellipsis()
        .db-ib
          display inline-block
          padding-right 5px
          line-height 36px
          width 49%
          vertical-align middle
          ellipsis()
      .look__detail
        position absolute
        bottom 9px
        .detail
          color #2b9efc
          text-decoration none
  .recommend__item--left
    .recommend__identify
      left 0
    .recommend__introduce
      width 1045px
      float right
      padding-left 368px
    .recommend__explain
        padding-right 89px
      .look__detail
        right 20px
  .recommend__item--right
    .recommend__identify
      right 0
    .recommend__introduce
      width 974px
      float left
      padding-left 36px
      padding-right 368px
      .recommend__desc
        padding-right 0
      .look__detail
        right 282px
</style>



// WEBPACK FOOTER //
// list.vue?0c4c4720